import jsep from 'jsep';

/** Evaluate the same arithmetic subset as the server, without executing JavaScript. */
export function evaluateFormula(formula: string, formData: Record<string, unknown>): number {
  if (formula.length > 4096) return 0;
  try {
    const expression = formula.replace(/\{([^{}]+)\}/g, (_match, key: string) => {
      const raw = Object.prototype.hasOwnProperty.call(formData, key) ? formData[key] : 0;
      const value = typeof raw === 'number' || typeof raw === 'string' ? Number(raw) : 0;
      return `(${Number.isFinite(value) ? value : 0})`;
    });
    if (!/^[\d.\s()+*/-]+$/.test(expression)) return 0;
    let remaining = 512;
    const read = (node: jsep.Expression, depth = 0): number => {
      if (--remaining < 0 || depth > 64) throw new Error('Formula is too complex');
      let value: number;
      if (node.type === 'Literal' && typeof (node as jsep.Literal).value === 'number') {
        value = (node as jsep.Literal).value as number;
      } else if (node.type === 'UnaryExpression') {
        const unary = node as jsep.UnaryExpression;
        if (unary.operator !== '+' && unary.operator !== '-') throw new Error('Invalid operator');
        value = read(unary.argument, depth + 1) * (unary.operator === '-' ? -1 : 1);
      } else if (node.type === 'BinaryExpression') {
        const binary = node as jsep.BinaryExpression;
        if (!['+', '-', '*', '/'].includes(binary.operator)) throw new Error('Invalid operator');
        const left = read(binary.left, depth + 1);
        const right = read(binary.right, depth + 1);
        switch (binary.operator) {
          case '+': value = left + right; break;
          case '-': value = left - right; break;
          case '*': value = left * right; break;
          default: value = left / right;
        }
      } else {
        throw new Error('Only numeric arithmetic is supported');
      }
      if (!Number.isFinite(value)) throw new Error('Non-finite result');
      return value;
    };
    return read(jsep(expression));
  } catch {
    return 0;
  }
}
